import { BackToBanner } from './back-to-banner';

export * from './back-to-banner-props';

export default BackToBanner;
